export default __webpack_public_path__ + "static/3-f5566878cbe2e9a5232cf15e55ad234e.jpeg";